import { createSelector } from 'reselect';
import { getSizotsaFuneralClaim } from './index';
import { FORM_STATUS } from '../../reducers/status';
import { OmValidationDateHelper } from '@om/validation';
import { calculateAge } from '../../functions/easiplusFuneralPlan/Util';

export const getDeceasedDetails = createSelector(
    getSizotsaFuneralClaim,
    (sizotsaFuneralClaim) => sizotsaFuneralClaim.deceasedDetails
);
export const getDeceasedDetailsForm = createSelector(getDeceasedDetails, (deceasedDetails) => deceasedDetails.form);
const makeGetField = (fieldId) =>
    createSelector(getDeceasedDetailsForm, (deceasedDetailsForm) => deceasedDetailsForm[fieldId]);

export const getFirstName = makeGetField('firstName');
export const getDecesedId = makeGetField('accountHolderId');


export const getDeceasedDetailsValidations = createSelector(getDeceasedDetailsForm, (deceasedDetailform) => {
    const {
        deceasedRelation,
        relationShip,
        title,
        firstName,
        middleName,
        lastName,
        dateOfDeath,
        accountHolderId,
        idSelected,
        placeOfDeath,
        cause,
        mentionedCause,
        reasonForDelay,
        dateOfBirth
    } = deceasedDetailform;
    // console.log(calculateAge(dateOfDeath?.value)>=1,'age');
    return {
        deceasedRelation,
        title,
        firstName,
        lastName,
        dateOfDeath,
        dateOfBirth,
        ...(dateOfDeath?.value && calculateAge(dateOfDeath?.value)>=1 && {reasonForDelay}),
        accountHolderId,
        idSelected,
        placeOfDeath,
        cause,
        // ...(!(['Spouse/Partner','Child'].includes(deceasedRelation?.displayValue))&&{relationShip}),
        ...(cause?.displayValue === 'Other' && { mentionedCause }),
    };
});

export const getDeceasedDetailsValid = createSelector(
    getDeceasedDetails,
    (deceasedDetails) => deceasedDetails.formStatus === FORM_STATUS.VALID
);

export const getDeceasedRelationShipList = createSelector(getDeceasedDetailsForm, (deceasedDetailsForm) => {
    const { deceasedRelation } = deceasedDetailsForm;
    const parentsInLawsRelations = [
        {
            code: 'Mother',
            description: 'Mother',
        },
        {
            code: 'Mother-in-law',
            description: 'Mother-in-law',
        },
        {
            code: 'Father',
            description: 'Father',
        },
        {
            code: 'Father-in-law',
            description: 'Father-in-law',
        },
        {
            code: 'Step father',
            description: 'Step father',
        },
        {
            code: 'Step mother',
            description: 'Step mother',
        },
        {
            code: 'Adoptive father',
            description: 'Adoptive father',
        },
        {
            code: 'Adoptive mother',
            description: 'Adoptive mother',
        },
    ];
    const extendedFamilyRelations = [
        {
            code: 'aunt',
            description: 'Aunt',
        },
        {
            code: 'Uncle',
            description: 'Uncle',
        },
        {
            code: 'Brother',
            description: 'Brother',
        },
        {
            code: 'Sister',
            description: 'Sister',
        },
        {
            code: 'Brother-in-law',
            description: 'Brother-in-law',
        },
        {
            code: 'Sister-in-law',
            description: 'Sister-in-law',
        },
        {
            code: 'Son-in-law',
            description: 'Son-in-law',
        },
        {
            code: 'Daughter-in-law',
            description: 'Daughter-in-law',
        },
        {
            code: 'Grand-father',
            description: 'Grand-father',
        },
        {
            code: 'Grand-mother',
            description: 'Grand-mother',
        },
        {
            code: 'Grand-son',
            description: 'Grand-son',
        },
        {
            code: 'Grand-daughter',
            description: 'Grand-daughter',
        },
        {
            code: 'Niece',
            description: 'Niece',
        },
        {
            code: 'First cousins',
            description: 'First cousins',
        },
        {
            code: 'Nephew',
            description: 'Nephew',
        },
        {
            code: 'Son',
            description: 'Son',
        },
        {
            code: 'Daughter',
            description: 'Daughter',
        },
        {
            code: 'Ex-husband',
            description: 'Ex-husband',
        },
        {
            code: 'Ex-wife',
            description: 'Ex-wife',
        },
    ];
    return ['Parent or Parent-in-law'].includes(deceasedRelation?.displayValue)
        ? parentsInLawsRelations
        : extendedFamilyRelations;
});


const inputFieldLabels = {
        deceasedRelation:'Relationship to policyholder',
        dateOfDeath:'Date of death',
        accountHolderId:'ID number',
        placeOfDeath:'Place of death',
        cause:'Cause of death',
        mentionedCause:'Other Cause of Death',
};

export const getDeceasedDetailsSummary = createSelector(
    getDeceasedDetailsForm,
    (formFieldsFiltered) => {
        const fullName = formFieldsFiltered['title']?.value+ ' ' +formFieldsFiltered['firstName']?.value + ' '+ (formFieldsFiltered['middleName']?.value ?? '') + ' ' + formFieldsFiltered['lastName']?.value
        console.log(formFieldsFiltered,'formFields');
        const deceasedDetailsSummary= Object.keys(formFieldsFiltered).flatMap((item) => {
            return {
                label: inputFieldLabels[item],
                value: formFieldsFiltered[item]?.displayValue ?? '-',
            };
        }).filter(({label})=>label);
        console.log(deceasedDetailsSummary,'formFields');
        return [{label:'Full name',value:fullName}, ...deceasedDetailsSummary, ]
    }
);